const postCategories = [
	{
		slug: "hosting",
		title: "Linux & Hosting",
		description:
			"Practical notes on Linux servers, hosting, and day-to-day systems administration—from config hardening to troubleshooting.",
		thumbnail: "tag1.png",
	},
	{
		slug: "devops",
		title: "DevOps",
		description:
			"Automation, pipelines, containers, and observability: patterns and lessons learned from real environments.",
		thumbnail: "tag1.png",
	},
	{
		slug: "homelab",
		title: "Homelab",
		description:
			"Home lab builds: virtualization, networking, and hardware experiments—safe sandboxes before production.",
		thumbnail: "tag1.png",
	},
	{
		slug: "productivity",
		title: "Productivity",
		description:
			"Tools, shortcuts, and workflows that reduce friction at the keyboard and when organizing work.",
		thumbnail: "tag1.png",
	},
	{
		slug: "networking",
		title: "Networking",
		description:
			"Networking fundamentals and beyond: addressing, routing, DNS, Wi‑Fi, and diagnosing connectivity issues.",
		thumbnail: "tag1.png",
	},
]

export function getPostCategoryBySlug(slug: string) {
	return postCategories.find((category) => category.slug === slug) || null;
}

export default postCategories
